
<modal v-if="state.isVisible"
       :custom-statuses="['exporting']"
       :prevent-esc="state.status === 'exporting'"
       :should-cancel-on-outside-click="state.status !== 'exporting'"
       :state="state"
       class="font-weight-normal"
       @toggle-modal="close"
>
  <h3 class="modal-title">Export CSV</h3>

  <slot :slot="ModalStatus.Confirmation" :name="ModalStatus.Confirmation" />

  <div slot="exporting" class="text-left">
    <export-progress-title-block :title="config.title" />
    <p v-if="lastBroadcast.tries > 1" class="text-grey text-base-i mb-0-i underline">
      Attempt #{{lastBroadcast.tries}}
    </p>
    <p class="text-grey text-base-i mb-0-i">Time remaining: {{progressETAMessage}}</p>
    <p class="text-grey text-base-i mb-4-i">Completion: {{progressPercentMessage}}</p>
    <progress-bar :max="progress.max" :min="0" :value="progress.value" bar-classes="green" class="mb-5-i" />
    <p class="text-grey text-base-i mb-0-i">File is exporting. We will notify you when it's complete.</p>
  </div>

  <div :slot="ModalStatus.Successful" class="text-left">
    <export-progress-title-block :title="config.title" />
    <p class="text-grey text-base-i">Export is complete.</p>
    <template v-for="(message, status) in lastBroadcast.messages">
      <flash-attribute-messages :messages="message" :status="status" class="mb-5-i" />
    </template>
    <div class="cta">
      <a :href="downloadData.href" class="btn blue block" target="_blank" @click="downloaded">Download</a>
    </div>
  </div>

  <div :slot="ModalStatus.Failure" class="text-left">
    <export-progress-title-block :title="config.title" />
    <div class="em-block red p-5-i mb-5-i">
      <h5 class="mb-0-i text-base-i">Export failed:</h5>
      <p class="mb-0-i text-base-i">{{failMsg}}</p>
      <p class="mb-0-i text-base-i">{{failTimeDisplay}}</p>
    </div>
  </div>
</modal>
